import type { WRealizationsTestimonialsTranslations } from "./pl";

export const de: WRealizationsTestimonialsTranslations = {
  defaultTitle: "Ausgewählte Projekte",
  seeRealization: "Projekt ansehen",
  seeAll: "Alle Projekte",
  prev: "Vorherige",
  next: "Nächste",
  goToSlide: "Zur Referenz",
};
